/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable no-plusplus */
/* eslint-disable import/prefer-default-export */
import moment from 'moment';
import { getLanguage, t } from 'react-switch-lang';
import Inputmask from 'inputmask';

const dateRegex = /(^(20|19|18)[0-9]{2}-[0-1][0-9]-[0-3][0-9]$)/;

export const FIELD_VALIDATION_REGEX = {
  VALID_CHAR: /^[a-zA-Z0-9&\-.,'‘’âàéêèëîìïôòûùüçÂÀÉÊÈËÎÌÏÔÒÙÜÛÇ()]+(?: [a-zA-Z0-9&\-.,'‘’âàéêèëîìïôòûùüçÂÀÉÊÈËÎÌÏÔÒÙÜÛÇ()]+)*$/,
  VALID_DECIMAL: /^\d+(\.\d+)?$/,
  INVALID_ASTERISK: /^(?!.*\*).*$/, // This regex matches with any string that does not contain an asterisk.
  VALID_EMAIL: /^[\w!#$%&*+/=?`{|}~^-]+(?:\.[\w!#$%&*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,32}$/,
  VALID_PHONE_NUMBER: /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/,
};

const NO_ERROR = Object.freeze({
  hasError: false,
  errorMessage: null,
});

export const VALIDATION_ERROR_MSG = {
  REGEX: 'regex',
  REGEX_NAME: 'regexName',
  EMPTY: 'empty',
  EMPTY_VALUE: 'emptyValue',
  RANGE: 'range',
  MAX: 'max',
  MIN: 'min',
  EXACT: 'exact',
  MIN_VALUE: 'minValue',
  MAX_VALUE: 'maxValue',
  BEFORE_DATE: 'beforeDate',
  AFTER_DATE: 'afterDate',
};

const DEFAULT_MAX_CHARACTERS = 30;

/**
 * Converts English and French currency notation to English currency notation
 * @returns {string}
 */
function normalizeAmount(value) {
  // remove spaces
  let unmasked = value.toString().replace(/\s/g, '');
  // remove dollar signs
  unmasked = unmasked.replace(/\$/g, '');

  // check if comma is at the location of a period (french currency cents)
  if (unmasked.lastIndexOf(',') !== -1 && (unmasked.length - unmasked.lastIndexOf(',') === 3 || unmasked.length - unmasked.lastIndexOf(',') === 2)) {
    const pos = unmasked.lastIndexOf(',');
    // replace comma with period
    // eslint-disable-next-line no-multi-spaces, template-curly-spacing
    unmasked = `${unmasked.substring(0, pos)  }.${  unmasked.substring(pos + 1)}`;
  } else {
    unmasked = unmasked.replace(/,/g, '');
  }
  return unmasked;
}

export function FormatAmount(rawAmount) {
  if (getLanguage() === 'fr') {
    const amount = Math.round(rawAmount * 100) / 100;
    const str = Number(amount).toFixed(2).toString().split('.');
    if (str[0].length >= 4) {
      str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    }
    if (str[1] && str[1].length >= 5) {
      str[1] = str[1].replace(/(\d{3})/g, '$1 ');
    }
    return `${str.join(',')} $`;
  }
  const amount = Math.round(rawAmount * 100) / 100;
  const str = Number(amount).toFixed(2).toString().split('.');
  if (str[0].length >= 4) {
    str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
  }
  if (str[1] && str[1].length >= 5) {
    str[1] = str[1].replace(/(\d{3})/g, '$1 ');
  }

  return `$${str.join('.')}`;
}

// if this function returns true, that means the validation is disabled/doesn't need to run
const isValidationDisabled = (validation) => validation === '99' || validation === '' || validation === null || validation === undefined;

function isValidDate(value) {
  if (!value) return t('Validation_Required');
  if (!dateRegex.test(value)) return t('Validation_Type_Date');
  if (!moment(value).isValid()) return t('Validation_Type_Date');
  if (moment(value).isBefore(moment('1899-12-31'))) return t('Validation_Type_Date');
  const date = new Date(value);
  if (!(date instanceof Date && !Number.isNaN(date.valueOf()))) return t('Validation_Type_Date');
  return undefined;
}

export const validateDate = (value) => (isValidDate(value));

export function CheckRegex(validationInfo, value) {
  if (!value) {
    return false;
  }
  return validationInfo.validation.regex.test(value);
}

/**
 * @param {string} mask
 * @param {import('../context/PaymentProcessContext').Validation} validation
 */
export const getDefaultMask = (mask, validation) => {
  let defaultMask = '';
  if (mask === '' || mask === null || mask === undefined) {
    defaultMask = '*'.repeat(DEFAULT_MAX_CHARACTERS);
    if (!validation) {
      return defaultMask;
    }
    if (!isValidationDisabled(validation.MaxLength)) {
      defaultMask = '*'.repeat(Number(validation.MaxLength));
    } else if (!isValidationDisabled(validation.ExactLength)) {
      defaultMask = '*'.repeat(Number(validation.ExactLength));
    } else if (!isValidationDisabled(validation.MinLength)) {
      defaultMask = '*'.repeat(Number(validation.MinLength));
    }
    return defaultMask;
  }
  return mask;
};

const isRegexValid = ({ Regex }, inputValue) => {
  if (isValidationDisabled(Regex.regex)) return NO_ERROR;
  if (!CheckRegex({ validation: { regex: Regex.regex } }, inputValue)) {
    const errMsg = Regex.customErrorMessage !== null ? Regex.customErrorMessage : t('Validation_AccountHolderName');
    return { hasError: true, errorMessage: errMsg };
  }
  return NO_ERROR;
};

const isAmountValid = ({ Amount }, inputValue) => {
  const isValidAmount = normalizeAmount(inputValue) >= Amount.MinPaymentAmount &&
    normalizeAmount(inputValue) <= Amount.MaxPaymentAmount;
  const errorMsg = t('Validation_Value_Range').replace('xMin', FormatAmount(Amount.MinPaymentAmount)).replace('xMax', FormatAmount(Amount.MaxPaymentAmount));
  if (isValidAmount) return NO_ERROR;
  return { hasError: true, errorMessage: errorMsg };
};

export function CheckRange(validationInfo, value) {
  if (!value) {
    return { check: false, type: VALIDATION_ERROR_MSG.EMPTY_VALUE };
  }

  if (
    validationInfo.validation.value.min &&
    value < validationInfo.validation.value.min
  ) {
    return { check: false, type: VALIDATION_ERROR_MSG.MIN_VALUE };
  }
  if (
    validationInfo.validation.value.max &&
    value > validationInfo.validation.value.max
  ) {
    return { check: false, type: VALIDATION_ERROR_MSG.MAX_VALUE };
  }

  return { check: true, type: null };
}

export function CheckLength(validationInfo, value) {
  if (!value) {
    return { check: false, type: VALIDATION_ERROR_MSG.EMPTY };
  }
  if (value.length === 0) {
    return { check: false, type: VALIDATION_ERROR_MSG.EMPTY };
  }

  if (
    validationInfo.validation.length.max &&
    value.length > validationInfo.validation.length.max
  ) {
    return { check: false, type: VALIDATION_ERROR_MSG.MAX };
  }
  if (
    validationInfo.validation.length.min &&
    value.length < validationInfo.validation.length.min
  ) {
    return { check: false, type: VALIDATION_ERROR_MSG.MIN };
  }
  if (
    validationInfo.validation.length.exact &&
    value.length !== validationInfo.validation.length.exact
  ) {
    return { check: false, type: VALIDATION_ERROR_MSG.EXACT };
  }
  return { check: true, type: null };
}

export function DateIsInPast(date) {
  if (!date) {
    return true;
  }

  const dateSelected = moment(date).startOf('day');
  const today = moment().startOf('day');

  return moment(dateSelected).isBefore(today, 'day');
}

const checkLengthWrapper = ({ MinLength, MaxLength, ExactLength, Type }, inputValue) => {
  const validationInfo = {
    validation: {
      length: {
        min: isValidationDisabled(MinLength) ? null : Number(MinLength),
        max: isValidationDisabled(MaxLength) ? null : Number(MaxLength),
        exact: isValidationDisabled(ExactLength) ? null : Number(ExactLength),
      },
    },
  };
  const unmasked = Type === 'AccountholderName' ? inputValue : inputValue.replace(/\s/g, '');
  const result = CheckLength(validationInfo, unmasked);
  const rangeErrorMessage = t('Validation_Length_Range');
  let errMsg = '';
  // using custom logic for error messages to reflect the error messages on paysimply web
  switch (result.type) {
    case 'min':
      errMsg = isValidationDisabled(MaxLength) ?
        t('Validation_Length_Min').replace('xMin', Number(MinLength)) :
        rangeErrorMessage.replace('xMin', Number(MinLength)).replace('xMax', Number(MaxLength));
      return { hasError: true, errorMessage: errMsg };
    case 'max':
      errMsg = isValidationDisabled(MinLength) ?
        t('Validation_Length_Max').replace('xMax', Number(MaxLength)) :
        rangeErrorMessage.replace('xMin', Number(MinLength)).replace('xMax', Number(MaxLength));
      return { hasError: true, errorMessage: errMsg };
    case 'exact':
      errMsg = t('Validation_Length_Exact').replace(
        'xLength',
        Number(ExactLength)
      );
      return { hasError: true, errorMessage: errMsg };
    default:
      return NO_ERROR;
  }
};

// For ValidStart, ValidEnd, InvalidStart and InvalidEnd the validations is a string which has
// multiple values separated by space. E.g. for ValidStart
// "110 120 100" means that a string is valid if it starts with 110 or 120 or 100.
export const isValidStart = ({ ValidStart }, inputValue) => {
  if (isValidationDisabled(ValidStart)) return NO_ERROR;
  const validStart = ValidStart.toString().split(' ');
  const filteredValidStart = validStart.filter((el) => el);
  const unmasked = inputValue.replace(/\s/g, '');
  for (let i = 0; i < filteredValidStart.length; i++) {
    if (unmasked.startsWith(filteredValidStart[i])) {
      return NO_ERROR;
    }
  }
  const errMsg = t('biller_ValidationRulesValidStart');
  const finalErrMsg = errMsg.replace('xValidStart', filteredValidStart.join(' or '))
    .replace('<strong>', '**')
    .replace('</strong>', '**');
  return { hasError: true, errorMessage: finalErrMsg };
};

export const isValidEnd = ({ ValidEnd }, inputValue) => {
  if (isValidationDisabled(ValidEnd)) return NO_ERROR;
  const validEnds = ValidEnd.toString().split(' ');
  const filteredValidEnd = validEnds.filter((el) => el);
  const unmasked = inputValue.replace(/\s/g, '');
  for (let i = 0; i < filteredValidEnd.length; i++) {
    if (unmasked.endsWith(filteredValidEnd[i])) {
      return NO_ERROR;
    }
  }
  const errMsg = t('biller_ValidationRulesValidEnd');
  const finalErrMsg = errMsg.replace('xValidEnd', filteredValidEnd.join(' or '))
    .replace('<strong>', '**')
    .replace('</strong>', '**');
  return { hasError: true, errorMessage: finalErrMsg };
};

export const isInvalidStart = ({ InvalidStart }, inputValue) => {
  if (isValidationDisabled(InvalidStart)) return NO_ERROR;
  const inValidStarts = InvalidStart.toString().split(' ');
  const filteredInValidStarts = inValidStarts.filter((el) => el);
  const unmasked = inputValue.replace(/\s/g, '');
  const errMsg = t('Validation_Value_Invalid');
  for (let i = 0; i < filteredInValidStarts.length; i++) {
    if (unmasked.startsWith(filteredInValidStarts[i])) {
      // Sending a generic error message for security reasons.
      return { hasError: true, errorMessage: errMsg };
    }
  }
  return NO_ERROR;
};

export const isInvalidEnd = ({ InvalidEnd }, inputValue) => {
  if (isValidationDisabled(InvalidEnd)) return NO_ERROR;
  const inValidEnds = InvalidEnd.toString().split(' ');
  const filteredInValidEnds = inValidEnds.filter((el) => el);
  const unmasked = inputValue.replace(/\s/g, '');
  const errMsg = t('Validation_Value_Invalid');
  for (let i = 0; i < filteredInValidEnds.length; i++) {
    if (unmasked.endsWith(filteredInValidEnds[i])) {
      // Sending a generic error message for security reasons.
      return { hasError: true, errorMessage: errMsg };
    }
  }
  return NO_ERROR;
};

// Mod 10 check Routine.
export const isCheckRoutineValid_M = (c) => {
  // If value of c (SIN/BN 000000000) less than 1, return false
  if (c < 1) {
    return false;
  }
  var cl = parseInt(c.substr(c.length - 1), 10);
  c = c.slice(0, -1);
  c = c.split('').reverse().join('');
  c = c.split('');
  var a = 2;
  var cm = [];
  for (let i = 0; i < c.length; i++) {
    if (a % 2 === 0) {
      // eslint-disable-next-line no-shadow
      let t = c[i] * 2;
      if (t > 9) {
        t -= 9;
      }
      cm.push(t);
    } else {
      cm.push(parseInt(c[i], 10));
    }
    a++;
  }
  var f = 0;
  for (var i = 0; i < cm.length; i++) {
    f += cm[i];
  }
  f += cl;
  if (f % 10 === 0) {
    return true;
  }
  return false;
};

const calculateMod11CheckDigit = (input) => {
  var sum = 0;
  input
    .split('')
    .reverse()
    .forEach((value, index) => {
      sum += parseInt(value, 10) * ((index % 6) + 2);
    });
  var sumMod11 = 11 - (sum % 11);
  if (sumMod11 > 9) {
    sumMod11 -= 10;
  }
  return sumMod11.toString();
};

// used for Revenu Quebec Payment Code (Modulus 11 check routine)
const checkRQPMod11 = (input) => {
  var checkDigitIndex = input.length - 1;
  return (
    input.substr(checkDigitIndex) ===
    calculateMod11CheckDigit(input.substr(0, checkDigitIndex))
  );
};

// Revenu Quebec custom validation for payment codes.
const isCheckRoutineValid_RQP = (value) => {
  value = value.toUpperCase();

  // The first character must be alphanumeric(excluding the letters I and O).
  if (value.substr(0, 1) === 'I' || value.substr(0, 1) === 'O') return false;

  // The second character must be alphanumeric.
  // The characters must be between the letter A and the letter M
  // inclusive(excluding the letter I), and only the digit zero is accepted.
  if (!/((?!I)[A-M]|0)/.test(value.substr(1, 1))) return false;

  // The third character must be alphanumeric
  // (excluding the letters I and O).Digits cannot be greater than seven.
  if (!/((?!I)(?!O)[A-Z]|[0-7])/.test(value.substr(2, 1))) return false;

  // The check digit in the payment code, in the last position,
  // must be valid according to the modulus 11 method.
  // This calculation is done only for positions 4 to 19.
  return checkRQPMod11(value.substr(3));
};

// Check routine to check if the date is the last day of a month (any year).
const isCheckRoutineValid_PEM = (value) => {
  if (!/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(value)) {
    return false;
  }
  var date = moment(value);
  const month = date.month();
  date.add(1, 'days');
  return date.month() !== month;
};

// Check routine to check if the date is the last day of the year.
const isCheckRoutineValid_PEY = (value) => {
  // check if valid date
  if (!/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(value)) {
    return false;
  }
  var date = moment(value);
  return date.month() === 11 && date.date() === 31;
};

// Check routine specific for PROV NB - PROPERTY TAXES.
const checkProvCheckRoutine_NB = (value) => {
  // length must be 8 digits
  if (Number.isNaN(parseInt(value, 10)) || value.length !== 8) {
    return false;
  }
  var sum = 0;
  // multiply each digit by counter starting at 2
  var multiplier = 2;
  for (let i = 0; i < value.length - 1; i++) {
    // The results are summed.
    sum += multiplier * value.charAt(i);
    multiplier++;
  }

  // The sum is divided by 10 to obtain the remainder
  var remainder = sum % 10;

  // If the remainder equals the 8th digit of the account number then VALID ACCOUNT
  return parseInt(value.charAt(7), 10) === remainder;
};

// Company specific validations.
// S001 -> Prov NB check routine.
const isCheckRoutineValid_S = (value, CheckRoutine) => {
  const validSRoutine = /^S\d{3}/g;
  if (validSRoutine.test(CheckRoutine)) {
    if (CheckRoutine === 'S001') {
      return checkProvCheckRoutine_NB(value);
    }
    // This means, the app needs to be updated.
    // This mean, the check routine is not implemented yet.
    return true;
  }
  return true;
};

function EBCDIC(c) {
  switch (c) {
    case 'A':
    case 'J':
      return '1';
    case 'B':
    case 'K':
    case 'S':
      return '2';
    case 'C':
    case 'L':
    case 'T':
      return '3';
    case 'D':
    case 'M':
    case 'U':
      return '4';
    case 'E':
    case 'N':
    case 'V':
      return '5';
    case 'F':
    case 'O':
    case 'W':
      return '6';
    case 'G':
    case 'P':
    case 'X':
      return '7';
    case 'H':
    case 'Q':
    case 'Y':
      return '8';
    case 'I':
    case 'R':
    case 'Z':
      return '9';
    default:
      return '';
  }
}

function setEBCDIC(str, index) {
  var c = str.substr(index, 1);
  var e = EBCDIC(c);
  return str.substr(0, index) + e + str.substr(index + 1);
}

/**
 * Checks if a given date is between two specified dates, inclusive of the dates specified.
 *
 * @param {moment.Moment} inputDate - The date to check.
 * @param {moment.Moment} minDate - The minimum date in the range.
 * @param {moment.Moment} maxDate - The maximum date in the range.
 * @returns {boolean} - Returns true if the inputDate is between minDate and maxDate;
 * otherwise, false.
 */
function isDateBetween(inputDate, minDate, maxDate) {
  // need to format min and max dates to date strings before comparing in order to ignore time
  return inputDate.isBetween(minDate.format('YYYY-MM-DD'), maxDate.format('YYYY-MM-DD'), undefined, '[]');
}

/**
 * @param {object} validations
 * @param {import('../context/PaymentProcessContext').CheckRoutine} validations.CheckRoutine
 */
export const isCheckRoutineValid = ({ CheckRoutine }, inputValue, mask) => {
  // We need to support:
  // M, S, RQP, PEM, PYE, S001
  // For check routines starting with S,
  // we need to ensure that the check routine code is in correct format.
  // S followed by the 3 numbers
  const trimmed = inputValue.toString().replace(/\s/g, '');
  if (isValidationDisabled(CheckRoutine)) return NO_ERROR;
  const errMsg = t('Validation_Value_Invalid');
  if (CheckRoutine === 'M') {
    return isCheckRoutineValid_M(trimmed) ?
      NO_ERROR :
      { hasError: true, errorMessage: errMsg };
  }
  if (CheckRoutine === 'RQP') {
    return isCheckRoutineValid_RQP(trimmed) ?
      NO_ERROR :
      { hasError: true, errorMessage: errMsg };
  }
  if (CheckRoutine === 'PEM') {
    return isCheckRoutineValid_PEM(trimmed) ?
      NO_ERROR :
      { hasError: true, errorMessage: errMsg };
  }
  if (CheckRoutine === 'PEY') {
    return isCheckRoutineValid_PEY(trimmed) ?
      NO_ERROR :
      { hasError: true, errorMessage: errMsg };
  }
  if (CheckRoutine.startsWith('S')) {
    return isCheckRoutineValid_S(trimmed, CheckRoutine) ?
      NO_ERROR :
      { hasError: true, errorMessage: `${errMsg}` };
  }
  if (CheckRoutine === 'CRANRA') {
    let unmasked = trimmed;
    unmasked = setEBCDIC(unmasked, 0);
    unmasked = setEBCDIC(unmasked, 1);
    unmasked = setEBCDIC(unmasked, 2);
    return isCheckRoutineValid_M(unmasked) ?
      NO_ERROR :
      { hasError: true, errorMessage: errMsg };
  }
  if (CheckRoutine === 'CRABIN') {
    const unmasked = Inputmask.unmask(inputValue, { mask });
    return isCheckRoutineValid_M(unmasked.substring(0, 9)) ?
      NO_ERROR :
      { hasError: true, errorMessage: errMsg };
  }
  if (CheckRoutine === 'CRAPE1') {
    // Period end (+10years, -10years)
    const date = moment(inputValue);
    const minDate = moment().subtract(10, 'years');
    const maxDate = moment().add(10, 'years');
    return date.isValid() && isDateBetween(date, minDate, maxDate) ?
      NO_ERROR :
      { hasError: true, errorMessage: errMsg };
  }
  if (CheckRoutine === 'CRAPE2') {
    // Period end (+1year, -8years)
    const date = moment(inputValue);
    const minDate = moment().subtract(8, 'years');
    const maxDate = moment().add(1, 'years');
    return date.isValid() && isDateBetween(date, minDate, maxDate) ?
      NO_ERROR :
      { hasError: true, errorMessage: errMsg };
  }
  if (CheckRoutine === 'CRAPE3') {
    // Period end (+3months, -8years)
    const date = moment(inputValue);
    const minDate = moment().subtract(8, 'years');
    const maxDate = moment().add(3, 'months');
    return date.isValid() && isDateBetween(date, minDate, maxDate) ?
      NO_ERROR :
      { hasError: true, errorMessage: errMsg };
  }
  if (CheckRoutine === 'CRAT3TA') {
    const unmasked = setEBCDIC(trimmed, 0);
    return isCheckRoutineValid_M(unmasked) ?
      NO_ERROR :
      { hasError: true, errorMessage: errMsg };
  }
  return NO_ERROR;
};

export const validationHelper = (validations, inputValue, mask) => {
  if (!validations) {
    return NO_ERROR;
  }
  if (!inputValue || inputValue === '' || inputValue === null) {
    return { hasError: true, errorMessage: t('Validation_Required') };
  }

  if (isValidationDisabled(validations.MaxLength) &&
      isValidationDisabled(validations.MinLength) &&
      isValidationDisabled(validations.ExactLength)) {
    // eslint-disable-next-line no-param-reassign
    validations = { ...validations, MaxLength: DEFAULT_MAX_CHARACTERS };
  }
  // Validations will run in the following order.
  const validationStrategies = {
    ValidStart: isValidStart,
    MinLength: checkLengthWrapper,
    MaxLength: checkLengthWrapper,
    ExactLength: checkLengthWrapper,
    ValidEnd: isValidEnd,
    InvalidStart: isInvalidStart,
    InvalidEnd: isInvalidEnd,
    CheckRoutine: isCheckRoutineValid,
    Regex: isRegexValid,
    Amount: isAmountValid,
  };

  const validationResults = Object.entries(validationStrategies).map(
    ([validationName, validationFunction]) => {
      if (validations[validationName]) {
        return validationFunction(validations, inputValue, mask);
      }
      return NO_ERROR;
    }
  );
  const error = validationResults.find(
    (element) => (element ? element.hasError : false)
  ) || { hasError: false, errorMessage: null };
  return error;
};
